import mq from 'styles/media';
import styled from 'styled-components/macro';

export const WrapperPage = styled.main`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ContentPage = styled.div`
  text-align: center;
  max-width: 610px;
  padding: 0 25px;
  h5 {
    font-size: 23px;
    margin-bottom: 23px;
    ${mq.minSm} {
      font-size: 36px;
    }
  }
  h1 {
    font-size: 32px;
    font-weight: bold;
    line-height: 120%;
    margin-bottom: 30px;
    ${mq.minSm} {
      font-size: 68px;
      margin-bottom: 45px;
    }
  }
  button {
    font-size: 15px;
    font-weight: 700;
    border-radius: 50px;
    padding: 17px 28px 18px;
    background: #ffc229;
  }
`;
